module.exports = __webpack_public_path__ + "img/SY.71141b29.png";